import { useCallback, ChangeEventHandler } from 'react';
import { IModalOptions } from './useModal.types';
import { useBoolean } from '../useBoolean';

export const useModalCheckboxState = <T = IModalOptions,>(
  createModalOptions: (modalCheckboxState: {
    isChecked: boolean;
    resetCheckbox: () => void;
    handleCheckboxChange: ChangeEventHandler<HTMLInputElement>;
  }) => T,
) => {
  const { value: isChecked, setFalse: resetCheckbox, set } = useBoolean(false);

  const handleCheckboxChange = useCallback((event) => set(event.target.checked), [set]);

  return createModalOptions({ isChecked, resetCheckbox, handleCheckboxChange });
};
